import React from "react";
import DateTimeRange from "../../../components/common/DateTimeRange";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";
import $ from "jquery";
import { toast } from "react-toastify";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";
const NewExtensionsDetails = () => {
  const { auth } = useAuth();
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [extensionData, setExtensionData] = useState();
  const [emailError, setEmailError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [nicError, setNicError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [pwdPassword, setPwdPassword] = useState(false);

  const [submittedData, setSubmittedData] = useState({
    INTERNET_QOUTA: "",
    MSG_QOUTA: "",
    NIC: "",
    OG_QOUTA: "",
    extension_name: "",
    REC_QOUTA: "",
    VM_QOUTA: "",
    callgroup: "",
    email: "",
    extension_number: extensionData?.data?.extension_number,
    package_id: auth.package_id,
    password: "",
    password_confirm: "",
    recording: $("#call_record").is(":checked") === true ? "1" : "0",
    status: "",
    username: "",
    vpbx_id: auth.vpbx_id,
  });

  const handleGroups = () => {
    let groups = "";
    groups = extensionData?.groups.map((val, index) => (
      <option key={index} value={val.group_name}>
        {val.group_name}
      </option>
    ));
    return groups;
  };
  //   useEffect(()=>{
  // if(params.extension_number){
  //   getEditExtesnion()
  // }
  //   },[])

  const ValidateEmail = (value) => {
    var mailformat = /^[A-Za-z][\w$.]+@[\w]+\.\w+$/;
    if (mailformat.test(value)) {
      return "Valid Email";
    } else {
      return "Invalid Email";
    }
  };
  const handleEmailValidation = (e) => {
    var Email = ValidateEmail(e);
    if (Email === "Invalid Email") {
      setEmailError("Invalid Email Address");
    } else {
      setEmailError("Valid Email Address");
    }
  };
  const statusArray = [
    {
      name: "Active",
      value: "1",
    },
    {
      name: "InActive",
      value: "0",
    },
  ];
  const getExtesnions = () => {
    axios
      .post(
        url + "edit-extension",
        {
          extension_number: sessionStorage.getItem("extesnion"),
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setExtensionData([]);
            } else if (response.data.message === "Data Found") {
              setExtensionData(response?.data?.data);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const handlePasswordValidation = (e) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/;
    let testedPassword = passwordRegex.test(e);

    if (testedPassword === false) {
      setPasswordError("Validation error");
    } else if (e.length < 14) {
      setPasswordError("Invalid password");
    } else {
      setPasswordError("");
    }
  };
  const handleNICValidation = (e) => {
    if (e.length !== 13) {
      setNicError("Invalid NIC");
    } else {
      setNicError("");
    }
  };
  const handleMobileNumberValidation = (e) => {
    if (e.length !== 11) {
      setMobileNumberError("Invalid mobile number");
    } else {
      setMobileNumberError("");
    }
  };
  const handleConfirmPwdValidation = (e) => {
    if (e === submittedData.password) {
      setPwdPassword(true);
    } else {
      setPwdPassword(false);
    }
  };
  useEffect(() => {
    handleEmailValidation(extensionData?.data?.email);
    setSubmittedData({
      ///hidden
      INTERNET_QOUTA: extensionData?.data?.INTERNET_QOUTA,
      MSG_QOUTA: extensionData?.data?.MSG_QOUTA,
      ////
      NIC: extensionData?.data?.NIC == null ? "" : extensionData?.data?.NIC,
      extension_name: extensionData?.data.extension_name,
      OG_QOUTA: extensionData?.data?.OG_QOUTA,
      REC_QOUTA: extensionData?.data?.REC_QOUTA,
      VM_QOUTA: extensionData?.data?.VM_QOUTA,
      callgroup: "",
      email: extensionData?.data?.email,
      extension_number: extensionData?.data?.extension_number,
      package_id: auth.package_id,
      password: "",
      password_confirm: "",
      recording: extensionData?.data?.recording,
      status: extensionData?.data?.status,
      username: extensionData?.data?.username,
      vpbx_id: auth.vpbx_id,
    });
  }, [extensionData]);

  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("extensions", "read_and_write"))
    ) {
      window.location.href = "/";
    }
    getExtesnions();
  }, []);

  const editExtesnion = (e) => {
    e.preventDefault();
    setErrorEnable(true);
    setLoader(true);
    if (
      submittedData.status !== "" &&
      submittedData.email !== "" &&
      emailError === "Valid Email Address" &&
      submittedData.username !== "" &&
      submittedData.NIC !== "" &&
      submittedData.password !== "" &&
      submittedData.password_confirm !== "" &&
      submittedData.callgroup !== "" &&
      submittedData.extension_name !== "" &&
      submittedData.extension_name !== null &&
      pwdPassword === true &&
      passwordError === "" &&
      mobileNumberError === "" &&
      nicError === ""
    ) {
      axios
        .post(url + "update-extension", submittedData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "sip has been updated.") {
                setLoader(false);
                toast.success("Extesnion added Successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/vpbx-manager";
                }, 2000);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/vpbx-manager">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>Edit Extesnion</h3>
                <p>
                  Please enter the details for the new extension, including the
                  email, mobile number, CNIC, and extension quota.
                </p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
            <div className="dashboardIntro uk-text-right">
              <button>EXPORT DATA</button>
            </div>
          </div> */}
          </div>
          <form onSubmit={editExtesnion}>
            <div className="uk-grid" uk-grid>
              <div className="uk-width-1-2@m">
                <div className="formCreateMain">
                  <div className="uk-grid uk-grid-small">
                    <div className="uk-width-1-1@m uk-margin-top">
                      <legend className="uk-legend">
                        Edit extension details{" "}
                        {extensionData?.data?.extension_number}
                      </legend>
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Status</label>
                      <select
                        className="uk-select"
                        aria-label="Select"
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            status: e.target.value,
                          });
                        }}
                      >
                        <option value="" selected>
                          Select Status...
                        </option>
                        {statusArray.map((val, index) => {
                          return (
                            <option
                              key={index}
                              value={val.value}
                              selected={
                                val.value === extensionData?.data?.status
                              }
                            >
                              {val.name}
                            </option>
                          );
                        })}
                      </select>
                      {errorEnable && submittedData.status === "" && (
                        <div className="formErrors">status is required</div>
                      )}
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Extension</label>
                      <input
                        className="uk-input"
                        type="text"
                        placeholder="Input"
                        aria-label="Input"
                        value={extensionData?.data?.extension_number}
                        disabled
                      />
                    </div>
                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Extension Name</label>
                      <input
                        className="uk-input"
                        type="text"
                        placeholder="please enter extesnion name"
                        value={extensionData?.data?.extension_name}
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            extension_name: e.target.value,
                          });
                        }}
                      />
                      {(submittedData.extension_name === "" ||
                        submittedData.extension_name === null) &&
                        errorEnable && (
                          <div className="formErrors">
                            extesnion name is required
                          </div>
                        )}
                    </div>
                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Email Address</label>
                      <input
                        className="uk-input"
                        type="text"
                        placeholder="Email Address"
                        aria-label="Input"
                        // required
                        defaultValue={extensionData?.data?.email}
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            email: e.target.value,
                          });
                          handleEmailValidation(e.target.value);
                        }}
                      />
                      {submittedData.email !== "" &&
                        errorEnable &&
                        emailError !== "Valid Email Address" && (
                          <div className="formErrors">
                            Invalid Email Address
                          </div>
                        )}
                      {submittedData.email === "" && errorEnable && (
                        <div className="formErrors">email is required</div>
                      )}
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>
                        Mobile Number: *this will be use as login id for
                        user/extension
                      </label>
                      <input
                        className="uk-input"
                        type="text"
                        placeholder="Please mobile number"
                        aria-label="Input"
                        // readOnly
                        defaultValue={extensionData?.data?.username}
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            username: e.target.value,
                          });
                          handleMobileNumberValidation(e.target.value);
                        }}
                      />
                      {submittedData.username === "" && errorEnable && (
                        <div className="formErrors">mobile is required</div>
                      )}
                      {submittedData.username !== "" &&
                        errorEnable &&
                        mobileNumberError === "Invalid mobile number" && (
                          <div className="formErrors">
                            mobile number must be 11 charcters long
                          </div>
                        )}
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>NIC#*</label>
                      <input
                        className="uk-input"
                        type="text"
                        placeholder="Enter Nic Number"
                        aria-label="Input"
                        // required

                        defaultValue={extensionData?.data?.NIC}
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            NIC: e.target.value,
                          });
                          handleNICValidation(e.target.value);
                        }}
                      />
                      {submittedData.NIC === "" && errorEnable && (
                        <div className="formErrors">NIC is required</div>
                      )}

                      {submittedData.NIC !== "" &&
                        errorEnable &&
                        nicError === "Invalid NIC" && (
                          <div className="formErrors">
                            NIC must be 13 characters long{" "}
                          </div>
                        )}
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Password*</label>
                      <input
                        className="uk-input"
                        type="password"
                        placeholder=""
                        aria-label="Input"
                        // required
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            password: e.target.value,
                          });
                          handlePasswordValidation(e.target.value);
                        }}
                      />
                      {submittedData.password === "" && errorEnable && (
                        <div className="formErrors">password is required</div>
                      )}
                      {submittedData.password !== "" &&
                        errorEnable &&
                        passwordError === "Invalid password" && (
                          <div className="formErrors">
                            password must be 14 characters{" "}
                          </div>
                        )}
                      {submittedData.password !== "" &&
                        errorEnable &&
                        passwordError === "Validation error" && (
                          <div className="formErrors">
                            password must includes uppercase, lowercase, numbers
                            and special characters
                          </div>
                        )}
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Confirm Password*</label>
                      <input
                        className="uk-input"
                        type="password"
                        placeholder=""
                        aria-label="Input"
                        // required
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            password_confirm: e.target.value,
                          });
                          handleConfirmPwdValidation(e.target.value);
                        }}
                      />
                      {submittedData.password_confirm === "" && errorEnable && (
                        <div className="formErrors">
                          confirm password is required
                        </div>
                      )}
                      {submittedData.password_confirm !== "" &&
                        errorEnable &&
                        pwdPassword === false && (
                          <div className="formErrors">
                            password and confirm password not matched{" "}
                          </div>
                        )}
                    </div>
                    {/* <div className="uk-grid uk-margin-top" uk-grid>
                      <div className="uk-width-1-3@m uk-margin">
                        <label>
                          <b>Working hours</b>
                        </label>
                        <label>Monday</label>
                        <label className="CheckBoxLabel">
                          <input className="uk-checkbox" type="checkbox" />{" "}
                          <span>Closed</span>
                        </label>
                      </div>
                      <div className="uk-width-1-3@m uk-margin-top">
                        <label>Start time</label>
                        <select className="uk-select" aria-label="Select">
                          <option value="" selected disabled hidden>
                            Select time...
                          </option>
                          <option></option>
                        </select>
                      </div>
                      <div className="uk-width-1-3@m uk-margin-top">
                        <label>End time</label>
                        <select className="uk-select" aria-label="Select">
                          <option value="" selected disabled hidden>
                            Select time...
                          </option>
                          <option>Active</option>
                          <option>Inactive</option>
                        </select>
                      </div>
                      <div className="uk-width-1-1@m uk-margin-top">
                        <label>
                          <b>Upload IVR flow</b>
                        </label>
                        <span className="fileDisc">
                          Only .zip ﬁles.900kb max ﬁle size.
                        </span>
                        <div className="uk-margin-bottom">
                          <div uk-form-custom="target: true">
                            <input
                              type="file"
                              aria-label="Custom controls"
                              accept=".zip"
                            />
                            <input
                              className="uk-input uk-form-width-medium"
                              type="text"
                              placeholder="Choose files"
                              aria-label="Custom controls"
                              disabled
                            />
                          </div>
                        </div>
                        <a href="#" className="DownloadFileBtn">
                          {" "}
                          Download sample file
                        </a>
                      </div>
                    </div> */}

                    {/* <div className="uk-width-1-1@m uk-float-right">
                      <div className="formActionBtn uk-text-right">
                        <button className="whiteBtn">Cancel</button>
                        <button className="pinkBtn">Save</button>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="uk-width-1-2@m">
                <div className="formCreateMain">
                  <div className="uk-grid uk-grid-small">
                    <div className="uk-width-1-1@m uk-margin-top">
                      <legend className="uk-legend">
                        EXTENSION QOUTA SETTINGS
                      </legend>
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Outgoing Voice (Minutes)</label>
                      <input
                        className="uk-input"
                        type="number"
                        placeholder="10"
                        aria-label="Input"
                        defaultValue={extensionData?.data?.OG_QOUTA}
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            OG_QOUTA: e.target.value,
                          });
                        }}
                      />
                      {/* {errorEnable && submittedData.VM_QOUTA === "" && (
                        <div className="formErrors">Outgoing Voice is required</div>
                      )} */}
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Groups</label>
                      <select
                        className="uk-select"
                        aria-label="Select"
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            callgroup: e.target.value,
                          });
                        }}
                      >
                        <option value="" selected>
                          Select Status...
                        </option>
                        {handleGroups()}
                      </select>
                      {submittedData.callgroup === "" && errorEnable && (
                        <div className="formErrors">please select group</div>
                      )}
                    </div>

                    <div className="uk-width-1-1@m uk-margin">
                      <label>
                        <b>Activated/De-Activated</b>
                      </label>
                      <label className="CheckBoxLabel">
                        <input
                          className="uk-checkbox"
                          type="checkbox"
                          id="call_record"
                          defaultChecked={
                            submittedData.recording === "1" ? true : false
                          }
                        />
                        <span>Call Recording Activated/De-Activated</span>
                      </label>
                    </div>

                    <div className="uk-width-1-1@m uk-margin-top">
                      <label>Recording Quota (MB)</label>
                      <input
                        className="uk-input"
                        type="number"
                        placeholder="10"
                        aria-label="Input"
                        defaultValue={extensionData?.data?.REC_QOUTA}
                        onChange={(e) => {
                          setSubmittedData({
                            ...submittedData,
                            REC_QOUTA: e.target.value,
                          });
                        }}
                      />
                      {/* {errorEnable && submittedData.VM_QOUTA === "" && (
                        <div className="formErrors">Outgoing Voice is required</div>
                      )} */}
                    </div>

                    <div className="uk-width-1-1@m uk-float-right uk-margin-large-top">
                      <div className="formActionBtn uk-text-right">
                        <button className="pinkBtn" type="submit">
                          {loader ? (
                            <div uk-spinner="" className="loader">
                              Adding
                            </div>
                          ) : (
                            "Edit Extension"
                          )}
                        </button>
                      </div>
                    </div>

                    {/* <div className="uk-width-1-1@m uk-float-right uk-margin-large-top">
                      <div className="formActionBtn uk-text-right">
                        <button className="whiteBtn">Cancel</button>
                        <button className="pinkBtn">Save</button>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewExtensionsDetails;
